const DRIVER_TOKEN_KEY = 'dn_driver_token'
const DRIVER_TOKEN_DECODED_KEY = `${DRIVER_TOKEN_KEY}_decoded`

const DRIVER_ROUTE_PREFIXES = [
  '/driver-application',
  '/driver-login',
  '/c',
  '/public-short-form',
  '/short-form',
]

export const getActiveDriverToken = (): string | null => {
  try {
    const { pathname } = window.location
    const onDriverRoute = DRIVER_ROUTE_PREFIXES.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
    return onDriverRoute ? getDriverToken() : null
  } catch {
    return null
  }
}

export const getDriverToken = (): string | null => {
  try {
    return window.localStorage.getItem(DRIVER_TOKEN_KEY)
  } catch {
    return null
  }
}

export const setDriverToken = (token: string): void => {
  try {
    window.localStorage.setItem(DRIVER_TOKEN_KEY, token)
    const decoded = decodeDriverToken(token)
    if (decoded) {
      window.localStorage.setItem(
        DRIVER_TOKEN_DECODED_KEY,
        JSON.stringify(decoded, null, 2)
      )
    } else {
      window.localStorage.removeItem(DRIVER_TOKEN_DECODED_KEY)
    }
  } catch {
    // ignore storage errors (private mode, etc.)
  }
}

export const clearDriverToken = (): void => {
  try {
    window.localStorage.removeItem(DRIVER_TOKEN_KEY)
    window.localStorage.removeItem(DRIVER_TOKEN_DECODED_KEY)
  } catch {
    // ignore storage errors
  }
}

export const decodeDriverToken = (
  token: string
): Record<string, unknown> | null => {
  try {
    const payload = token.split('.')[1]
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded)
  } catch {
    return null
  }
}
